import { render, staticRenderFns } from "./verified-step.vue?vue&type=template&id=0d24b27c"
import script from "./verified-step.vue?vue&type=script&lang=js"
export * from "./verified-step.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports